<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            シナリオを削除しますが、本当によろしいでしょうか？
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-danger" has-icon>
              削除されたシナリオを復元することはできません。
              またシナリオが繋がれている場合、繋がれた先のシナリオも消されてしまう可能性がございます。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive = false">いいえ</a>
          <a class="card-footer-item" @click="clickDeleteScenario()">はい</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'ModalDeleteScnario',
  data () {
    return {
      isCardModalActive: false,
      scenarioDelete: null
    }
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('chatbot', ['selectChatbot', 'scenarioTable', 'modalScenario', 'isModalDeleteScenario', 'isRoboPartsSetView']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalDeleteScenario () {
      this.isCardModalActive = this.isModalDeleteScenario
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    clickDeleteScenario () {
      this.sendControlLogRelatedChatBot('シナリオパーツ削除', 'シナリオ編集画面にて、シナリオパーツを削除した。', this.selectChatbot)
      this.scenarioDelete = this.modalScenario
      console.log('clickDeleteScenario:' + this.user.companyID)
      this.$store.dispatch('chatbot/deleteScenario', { companyid: this.user.companyID, scenarioName: this.scenarioDelete.name, scenarioId: this.scenarioDelete.beforenode })
      if (!this.isRoboPartsSetView) {
        this.setDeleteStatus(this.scenarioDelete)
      }
      for (let scenario of this.scenarioTable) {
        let update_flg = false
        for (let idx in scenario.select) {
          if (scenario.select[idx].next_node == this.scenarioDelete.beforenode) {
            scenario.select[idx].next_node = ''
            update_flg = true
          }
        }
        if (update_flg) {
          this.$store.dispatch('chatbot/setScenario', { companyid: this.user.companyID, scenarioName: scenario.name, scenario: scenario })
        }
      }
      this.$store.dispatch('chatbot/closeModalScenario')
      this.isCardModalActive = false
    },
    setDeleteStatus (scenario) {
      // ロボのパーツ削除情報を送信
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
        '[DELETESCENARIO]' + JSON.stringify(scenario)
      )
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalDeleteScenario.vue